import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-213" data-mp="21x22u3jf6kzn">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-xl border border-line border-l-4 border-l-gold bg-white p-4 pr-10 text-ink shadow-lift" aria-live="polite" data-id="element-214" data-mp="21yd704gs1ura">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-muted transition-colors duration-150 ease-out hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" aria-label="Cerrar aviso" data-id="element-215" data-mp="1sfwhqv0nisd0">
            <XIcon className="h-4 w-4" data-id="element-216" data-mp="1ng1ssx0fscul" />
          </button>
          <div className="flex gap-3" data-id="element-217" data-mp="1niny0pzuug9n">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-teal" data-id="element-218" data-mp="19p4zf3yorrmh" />
            <div data-id="element-219" data-mp="1efv6qmqoa4jt">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-teal" data-id="element-220" data-mp="1egeoa2ceuqxb">Acceso confirmado</p>
              <p className="mt-1 text-sm leading-snug" data-id="element-221" data-mp="zsa6r1p3glg4">
                Al completar tu compra, recibís el<br data-id="element-222" data-mp="14rda8hpfejlz" />
                <span className="font-bold text-deep" data-id="element-223" data-mp="14qv3us91up0c">Megapack Bibliotecología</span>
              </p>
              <p className="mt-2 text-xs text-muted" data-id="element-224" data-mp="qr2hf94k2uy6">Acceso digital inmediato</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}